import React, { useEffect, useState } from 'react';

const apiUrl = process.env.REACT_APP_API_URL || '';

const TrialRedirect: React.FC = () => {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const generateAndRedirect = async () => {
      try {
        const response = await fetch(`${apiUrl}/api/public/generate-trial-link`, {
          method: 'POST',
        });
        if (!response.ok) {
          setError('Failed to generate trial link. Please try again.');
          return;
        }
        const data = await response.json();
        window.location.href = data.invite_url;
      } catch {
        setError('Failed to connect to server. Please try again.');
      }
    };
    generateAndRedirect();
  }, []);

  if (error) {
    return (
      <div className="flex justify-center items-center h-screen">
        <p className="text-red-600">{error}</p>
      </div>
    );
  }

  return (
    <div className="flex justify-center items-center h-screen">
      <svg className="animate-spin h-8 w-8 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
    </div>
  );
};

export default TrialRedirect;
